module.exports = __webpack_public_path__ + "media/icons/play-d5063ca7.svg";